import { $ as e, B as t, C as n, D as r, E as i, F as a, G as o, I as s, J as c, K as l, L as u, O as d, P as f, Q as p, S as m, T as h, U as g, V as _, W as v, Y as y, Z as b, at as x, b as S, c as C, ct as w, d as T, et as E, f as D, h as O, it as k, l as A, n as j, nt as M, o as N, ot as P, r as F, rt as I, s as ee, st as te, t as ne, tt as L, u as R, v as re, w as z, x as ie, y as ae } from "./chunk-client-CLe1_f1Q.js";
import { a as oe, c as B, i as se, n as V, o as ce, r as le, s as H, t as ue } from "./chunk-useDebouncedQueryHook-BcPhu1xd.js";
import { r as de } from "./chunk-gqlOperations-CWLJsdMw.js";
//#region node_modules/instantsearch.js/es/lib/utils/clearRefinements.js
function fe(e) {
	var t = e.helper, n = e.attributesToClear, r = n === void 0 ? [] : n, i = t.state.setPage(0);
	return i = r.reduce(function(e, t) {
		return i.isNumericRefined(t) ? e.removeNumericRefinement(t) : i.isHierarchicalFacet(t) ? e.removeHierarchicalFacetRefinement(t) : i.isDisjunctiveFacet(t) ? e.removeDisjunctiveFacetRefinement(t) : i.isConjunctiveFacet(t) ? e.removeFacetRefinement(t) : e;
	}, i), r.indexOf("query") !== -1 && (i = i.setQuery("")), i;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/isFacetRefined.js
function pe(e, t, n) {
	return e.state.isHierarchicalFacet(t) ? e.state.isHierarchicalFacetRefined(t, n) : e.state.isConjunctiveFacet(t) ? e.state.isFacetRefined(t, n) : e.state.isDisjunctiveFacetRefined(t, n);
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/createSendEventForFacet.js
function me(e) {
	var t = e.instantSearchInstance, n = e.helper, r = e.attribute, i = e.widgetType;
	return function() {
		var e = [...arguments], a = M(e, 4), o = a[1], s = a[2], c = s === void 0 ? "Filter Applied" : s, l = a[3], u = l === void 0 ? {} : l, d = M(e[0].split(":"), 2), f = d[0], p = d[1], m = typeof r == "string" ? r : r(o);
		e.length === 1 && E(e[0]) === "object" ? t.sendEventToInsights(e[0]) : f === "click" && e.length >= 2 && e.length <= 4 && !pe(n, m, o) && t.sendEventToInsights({
			insightsMethod: "clickedFilters",
			widgetType: i,
			eventType: f,
			eventModifier: p,
			payload: k({
				eventName: c,
				index: n.lastResults?.index || n.state.index,
				filters: [`${m}:${o}`]
			}, u),
			attribute: m
		});
	};
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/escapeFacetValue.js
function he(e) {
	return typeof e == "string" ? e.replace(/^\\-/, "-") : e;
}
function U(e) {
	return typeof e == "number" && e < 0 || typeof e == "string" ? String(e).replace(/^-/, "\\-") : e;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/getRefinements.js
function W(e, t, n, r) {
	var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], a = {
		type: t,
		attribute: n,
		name: r,
		escapedValue: U(r)
	}, o = p(i, function(e) {
		return e.name === n;
	}), s;
	if (t === "hierarchical") {
		for (var c = function(e) {
			o = o && o.data && p(Object.keys(o.data).map(d(o.data)), function(t) {
				return t.name === u[e];
			});
		}, l = e.getHierarchicalFacetByName(n), u = r.split(l.separator), d = function(e) {
			return function(t) {
				return e[t];
			};
		}, f = 0; o !== void 0 && f < u.length; ++f) c(f);
		s = o && o.count;
	} else s = o && o.data && o.data[a.name];
	return s !== void 0 && (a.count = s), o && o.exhaustive !== void 0 && (a.exhaustive = o.exhaustive), a;
}
function ge(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = e || {}, i = [], a = t.facetsRefinements, o = a === void 0 ? {} : a, s = t.facetsExcludes, c = s === void 0 ? {} : s, l = t.disjunctiveFacetsRefinements, u = l === void 0 ? {} : l, d = t.hierarchicalFacetsRefinements, f = d === void 0 ? {} : d, p = t.numericRefinements, m = p === void 0 ? {} : p, h = t.tagRefinements, g = h === void 0 ? [] : h;
	return Object.keys(o).forEach(function(e) {
		o[e].forEach(function(n) {
			i.push(W(t, "facet", e, n, r.facets));
		});
	}), Object.keys(c).forEach(function(e) {
		c[e].forEach(function(t) {
			i.push({
				type: "exclude",
				attribute: e,
				name: t,
				exclude: !0
			});
		});
	}), Object.keys(u).forEach(function(e) {
		u[e].forEach(function(n) {
			i.push(W(t, "disjunctive", e, he(n), r.disjunctiveFacets));
		});
	}), Object.keys(f).forEach(function(e) {
		f[e].forEach(function(n) {
			i.push(W(t, "hierarchical", e, n, r.hierarchicalFacets));
		});
	}), Object.keys(m).forEach(function(e) {
		var t = m[e];
		Object.keys(t).forEach(function(n) {
			var r = n, a = t[r];
			(Array.isArray(a) ? a : [a]).forEach(function(t) {
				i.push({
					type: "numeric",
					attribute: e,
					name: `${t}`,
					numericValue: t,
					operator: r
				});
			});
		});
	}), g.forEach(function(e) {
		i.push({
			type: "tag",
			attribute: "_tags",
			name: e
		});
	}), n && t.query && t.query.trim() && i.push({
		attribute: "query",
		type: "query",
		name: t.query,
		query: t.query
	}), i;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/isFiniteNumber.js
function _e(e) {
	return typeof e == "number" && isFinite(e);
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/walkIndex.js
function ve(t, n) {
	n(t), t.getWidgets().forEach(function(t) {
		e(t) && ve(t, n);
	});
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/toArray.js
function G(e) {
	return Array.isArray(e) ? e : [e];
}
//#endregion
//#region node_modules/instantsearch.js/es/connectors/clear-refinements/connectClearRefinements.js
var ye = u({
	name: "clear-refinements",
	connector: !0
}), be = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : b;
	return d(e, ye()), function(n) {
		var r = n || {}, i = r.includedAttributes, a = i === void 0 ? [] : i, o = r.excludedAttributes, s = o === void 0 ? ["query"] : o, c = r.transformItems, l = c === void 0 ? function(e) {
			return e;
		} : c;
		if (n && n.includedAttributes && n.excludedAttributes) throw Error(ye("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
		var u = {
			refine: b,
			createURL: function() {
				return "";
			},
			attributesToClear: []
		}, d = function() {
			return u.refine();
		}, p = function() {
			return u.createURL();
		};
		return {
			$$type: "ais.clearRefinements",
			init: function(t) {
				var n = t.instantSearchInstance;
				e(I(k({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance;
				e(I(k({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !1);
			},
			dispose: function() {
				t();
			},
			getRenderState: function(e, t) {
				return I(k({}, e), { clearRefinements: this.getWidgetRenderState(t) });
			},
			getWidgetRenderState: function(e) {
				var t = e.createURL, r = e.scopedResults, i = e.results;
				u.attributesToClear = r.reduce(function(e, t) {
					return e.concat(xe({
						scopedResult: t,
						includedAttributes: a,
						excludedAttributes: s,
						transformItems: l,
						results: i
					}));
				}, []), u.refine = function() {
					u.attributesToClear.forEach(function(e) {
						var t = e.helper, n = e.items;
						t.setState(fe({
							helper: t,
							attributesToClear: n
						})).search();
					});
				}, u.createURL = function() {
					return t(f.apply(void 0, L(u.attributesToClear.map(function(e) {
						var t = e.helper, n = e.items;
						return fe({
							helper: t,
							attributesToClear: n
						});
					}))));
				};
				var o = u.attributesToClear.some(function(e) {
					return e.items.length > 0;
				});
				return {
					canRefine: o,
					hasRefinements: o,
					refine: d,
					createURL: p,
					widgetParams: n
				};
			}
		};
	};
};
function xe(e) {
	var t = e.scopedResult, n = e.includedAttributes, r = e.excludedAttributes, i = e.transformItems, o = e.results, s = n.indexOf("query") !== -1 || r.indexOf("query") === -1;
	return {
		helper: t.helper,
		items: i(a(ge(t.results, t.helper.state, s).map(function(e) {
			return e.attribute;
		}).filter(function(e) {
			return n.length === 0 || n.indexOf(e) !== -1;
		}).filter(function(e) {
			return e === "query" && s || r.indexOf(e) === -1;
		})), { results: o })
	};
}
//#endregion
//#region node_modules/react-instantsearch-core/dist/es/connectors/useClearRefinements.js
function K(e, t) {
	return O(be, e, t);
}
//#endregion
//#region node_modules/instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements.js
var Se = u({
	name: "current-refinements",
	connector: !0
}), Ce = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : b;
	return d(e, Se()), function(n) {
		if ((n || {}).includedAttributes && (n || {}).excludedAttributes) throw Error(Se("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
		var r = n || {}, i = r.includedAttributes, a = r.excludedAttributes, o = a === void 0 ? ["query"] : a, s = r.transformItems, c = s === void 0 ? function(e) {
			return e;
		} : s;
		return {
			$$type: "ais.currentRefinements",
			init: function(t) {
				var n = t.instantSearchInstance;
				e(I(k({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance;
				e(I(k({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !1);
			},
			dispose: function() {
				t();
			},
			getRenderState: function(e, t) {
				return I(k({}, e), { currentRefinements: this.getWidgetRenderState(t) });
			},
			getWidgetRenderState: function(e) {
				var t = e.results, r = e.scopedResults, a = e.createURL, s = e.helper;
				function l() {
					return t ? r.reduce(function(e, n) {
						return e.concat(c(we({
							results: n.results,
							helper: n.helper,
							indexId: n.indexId,
							includedAttributes: i,
							excludedAttributes: o
						}), { results: t }));
					}, []) : c(we({
						results: null,
						helper: s,
						indexId: s.state.index,
						includedAttributes: i,
						excludedAttributes: o
					}), { results: t });
				}
				var u = l();
				return {
					items: u,
					canRefine: u.length > 0,
					refine: function(e) {
						return Ee(s, e);
					},
					createURL: function(e) {
						return a(Te(s.state, e));
					},
					widgetParams: n
				};
			}
		};
	};
};
function we(e) {
	var t = e.results, n = e.helper, r = e.indexId, i = e.includedAttributes, a = e.excludedAttributes, o = (i || []).indexOf("query") !== -1 || (a || []).indexOf("query") === -1, s = i ? function(e) {
		return i.indexOf(e.attribute) !== -1;
	} : function(e) {
		return a.indexOf(e.attribute) === -1;
	}, c = ge(t, n.state, o).map(Oe).filter(s);
	return c.reduce(function(e, t) {
		return L(e.filter(function(e) {
			return e.attribute !== t.attribute;
		})).concat([{
			indexName: n.state.index,
			indexId: r,
			attribute: t.attribute,
			label: t.attribute,
			refinements: c.filter(function(e) {
				return e.attribute === t.attribute;
			}).sort(function(e, t) {
				return e.type === "numeric" ? e.value - t.value : 0;
			}),
			refine: function(e) {
				return Ee(n, e);
			}
		}]);
	}, []);
}
function Te(e, t) {
	switch (e = e.resetPage(), t.type) {
		case "facet": return e.removeFacetRefinement(t.attribute, String(t.value));
		case "disjunctive": return e.removeDisjunctiveFacetRefinement(t.attribute, String(t.value));
		case "hierarchical": return e.removeHierarchicalFacetRefinement(t.attribute);
		case "exclude": return e.removeExcludeRefinement(t.attribute, String(t.value));
		case "numeric": return e.removeNumericRefinement(t.attribute, t.operator, String(t.value));
		case "tag": return e.removeTagRefinement(String(t.value));
		case "query": return e.setQueryParameter("query", "");
		default: return e;
	}
}
function Ee(e, t) {
	e.setState(Te(e.state, t)).search();
}
function De(e) {
	switch (e) {
		case ">=": return "≥";
		case "<=": return "≤";
		default: return e;
	}
}
function Oe(e) {
	var t = ke(e), n = e.operator ? `${De(e.operator)} ${e.name}` : e.name, r = {
		attribute: e.attribute,
		type: e.type,
		value: t,
		label: n
	};
	return e.operator !== void 0 && (r.operator = e.operator), e.count !== void 0 && (r.count = e.count), e.exhaustive !== void 0 && (r.exhaustive = e.exhaustive), r;
}
function ke(e) {
	return e.type === "numeric" ? Number(e.name) : "escapedValue" in e ? e.escapedValue : e.name;
}
//#endregion
//#region node_modules/react-instantsearch-core/dist/es/connectors/useCurrentRefinements.js
function q(e, t) {
	return O(Ce, e, t);
}
//#endregion
//#region node_modules/instantsearch.js/es/connectors/infinite-hits/connectInfiniteHits.js
var Ae = u({
	name: "infinite-hits",
	connector: !0
});
function je(e) {
	var t = e || {};
	return t.page, s(t, ["page"]);
}
function Me(e) {
	var t = e || {};
	return t.clickAnalytics, t.userToken, s(t, ["clickAnalytics", "userToken"]);
}
function Ne() {
	var e = null, t = null;
	return {
		read: function(n) {
			var r = n.state;
			return ae(t, je(r)) ? e : null;
		},
		write: function(n) {
			var r = n.state, i = n.hits;
			t = je(r), e = i;
		}
	};
}
function Pe(e) {
	return Object.keys(e).map(Number).sort(function(e, t) {
		return e - t;
	}).reduce(function(t, n) {
		return t.concat(e[n]);
	}, []);
}
var Fe = (function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : b;
	return d(e, Ae()), function(i) {
		var a = i || {}, o = a.escapeHTML, s = o === void 0 ? !0 : o, c = a.transformItems, l = c === void 0 ? function(e) {
			return e;
		} : c, u = a.cache, d = u === void 0 ? Ne() : u, f, p, h, g, _ = function(e, t) {
			var n = e.page, r = n === void 0 ? 0 : n, i = Object.keys(t).map(Number);
			if (i.length === 0) return r;
			var a;
			return (a = Math).min.apply(a, [r].concat(L(i)));
		}, v = function(e, t) {
			var n = e.page, r = n === void 0 ? 0 : n, i = Object.keys(t).map(Number);
			if (i.length === 0) return r;
			var a;
			return (a = Math).max.apply(a, [r].concat(L(i)));
		}, y = function(e, t) {
			return function() {
				var n = t();
				e.overrideStateWithoutTriggeringChangeEvent(I(k({}, e.state), { page: _(e.state, n) - 1 })).searchWithoutTriggeringOnStateChange();
			};
		}, b = function(e, t) {
			return function() {
				var n = t();
				e.setPage(v(e.state, n) + 1).search();
			};
		};
		return {
			$$type: "ais.infiniteHits",
			init: function(t) {
				e(I(k({}, this.getWidgetRenderState(t)), { instantSearchInstance: t.instantSearchInstance }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance, r = this.getWidgetRenderState(t);
				e(I(k({}, r), { instantSearchInstance: n }), !1), h("view:internal", r.currentPageHits);
			},
			getRenderState: function(e, t) {
				return I(k({}, e), { infiniteHits: this.getWidgetRenderState(t) });
			},
			getWidgetRenderState: function(e) {
				var t = e.results, a = e.helper, o = e.parent, c = e.state, u = e.instantSearchInstance, x, C, w = function() {
					var e = o.getPreviousState() || c;
					return d.read({ state: Me(e) }) || {};
				}, T, E = [], D = o.getPreviousState() || c, O = w(), k = t == null || (C = t.renderingContent) == null || (x = C.widgets) == null ? void 0 : x.banners?.[0];
				if (f || (f = function() {
					return y(a, w)();
				}, p = function() {
					return b(a, w)();
				}), h || (h = n({
					instantSearchInstance: u,
					helper: a,
					widgetType: this.$$type
				}), g = m({
					helper: a,
					widgetType: this.$$type,
					instantSearchInstance: u
				})), !t) T = D.page === void 0 || _(D, O) === 0;
				else {
					var A = D.page, j = A === void 0 ? 0 : A;
					s && t.hits.length > 0 && (t.hits = r(t.hits));
					var M = l(S(ie(t.hits, t.page, t.hitsPerPage), t.queryID), { results: t }), N = !1;
					ve(u.mainIndex, function(e) {
						!N && e.getWidgets().some(re) && (N = !0);
					});
					var P = !D.disjunctiveFacets?.length && !(D.facets || []).filter(function(e) {
						return e !== "*";
					}).length && !D.hierarchicalFacets?.length;
					O[j] === void 0 && !t.__isArtificial && u.status === "idle" && !(N && P) && (O[j] = M, d.write({
						state: Me(D),
						hits: O
					})), E = M, T = _(D, O) === 0;
				}
				var F = Pe(O), I = t ? t.nbPages <= v(D, O) + 1 : !0;
				return {
					hits: F,
					items: F,
					currentPageHits: E,
					sendEvent: h,
					bindEvent: g,
					banner: k,
					results: t || void 0,
					showPrevious: f,
					showMore: p,
					isFirstPage: T,
					isLastPage: I,
					widgetParams: i
				};
			},
			dispose: function(e) {
				var n = e.state;
				t();
				var r = n.setQueryParameter("page", void 0);
				return s ? r.setQueryParameters(Object.keys(z).reduce(function(e, t) {
					return I(k({}, e), x({}, t, void 0));
				}, {})) : r;
			},
			getWidgetUiState: function(e, t) {
				var n = t.searchParameters.page || 0;
				return n ? I(k({}, e), { page: n + 1 }) : e;
			},
			getWidgetSearchParameters: function(e, t) {
				var n = t.uiState, r = e;
				s && (r = e.setQueryParameters(z));
				var i = n.page ? n.page - 1 : 0;
				return r.setQueryParameter("page", i);
			}
		};
	};
});
//#endregion
//#region node_modules/react-instantsearch-core/dist/es/connectors/useInfiniteHits.js
function Ie(e, t) {
	return O(Fe, e, t);
}
//#endregion
//#region node_modules/instantsearch.js/es/connectors/numeric-menu/connectNumericMenu.js
var Le = u({
	name: "numeric-menu",
	connector: !0
}), Re = "ais.numericMenu", ze = function(e) {
	var t = e.instantSearchInstance;
	return function() {
		var e = [...arguments];
		if (e.length === 1) {
			t.sendEventToInsights(e[0]);
			return;
		}
	};
}, Be = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : b;
	return d(e, Le()), function(n) {
		var r = n || {}, i = r.attribute, a = i === void 0 ? "" : i, o = r.items, s = o === void 0 ? [] : o, c = r.transformItems, l = c === void 0 ? function(e) {
			return e;
		} : c;
		if (a === "") throw Error(Le("The `attribute` option is required."));
		if (!s || s.length === 0) throw Error(Le("The `items` option expects an array of objects."));
		var u = function(e) {
			return s.map(function(t) {
				var n = t.start, r = t.end, i = t.label;
				return {
					label: i,
					value: encodeURI(JSON.stringify({
						start: n,
						end: r
					})),
					isRefined: Ve(e, a, {
						start: n,
						end: r,
						label: i
					})
				};
			});
		}, d = {};
		return {
			$$type: Re,
			init: function(t) {
				var n = t.instantSearchInstance;
				e(I(k({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance;
				e(I(k({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !1);
			},
			dispose: function(e) {
				var n = e.state;
				return t(), n.removeNumericRefinement(a);
			},
			getWidgetUiState: function(e, t) {
				var n = t.searchParameters.getNumericRefinements(a), r = n["="] && n["="][0];
				if (r || r === 0) return I(k({}, e), { numericMenu: I(k({}, e.numericMenu), x({}, a, `${n["="]}`)) });
				var i = n[">="] && n[">="][0] || "", o = n["<="] && n["<="][0] || "";
				return Ue(I(k({}, e), { numericMenu: I(k({}, e.numericMenu), x({}, a, `${i}:${o}`)) }), a);
			},
			getWidgetSearchParameters: function(e, t) {
				var n = t.uiState, r = n.numericMenu && n.numericMenu[a], i = e.setQueryParameters({ numericRefinements: I(k({}, e.numericRefinements), x({}, a, {})) });
				if (!r) return i;
				if (r.indexOf(":") === -1) return i.addNumericRefinement(a, "=", Number(r));
				var o = M(r.split(":").map(parseFloat), 2), s = o[0], c = o[1], l = _e(s) ? i.addNumericRefinement(a, ">=", s) : i;
				return _e(c) ? l.addNumericRefinement(a, "<=", c) : l;
			},
			getRenderState: function(e, t) {
				return I(k({}, e), { numericMenu: I(k({}, e.numericMenu), x({}, a, this.getWidgetRenderState(t))) });
			},
			getWidgetRenderState: function(e) {
				var t = this, r = e.results, i = e.state, o = e.instantSearchInstance, s = e.helper, c = e.createURL;
				d.refine ||= function(e) {
					var t = He(s.state, a, e);
					d.sendEvent("click:internal", e), s.setState(t).search();
				}, d.createURL ||= function(e) {
					return function(n) {
						return c(function(r) {
							return t.getWidgetUiState(r, {
								searchParameters: He(e, a, n),
								helper: s
							});
						});
					};
				}, d.sendEvent ||= ze({ instantSearchInstance: o });
				var f = r ? r.nbHits === 0 : !0, p = u(i), m = !0, h = !0, g = !1, _ = void 0;
				try {
					for (var v = p[Symbol.iterator](), y; !(h = (y = v.next()).done); h = !0) {
						var b = y.value;
						if (b.isRefined && decodeURI(b.value) !== "{}") {
							m = !1;
							break;
						}
					}
				} catch (e) {
					g = !0, _ = e;
				} finally {
					try {
						!h && v.return != null && v.return();
					} finally {
						if (g) throw _;
					}
				}
				return {
					createURL: d.createURL(i),
					items: l(p, { results: r }),
					hasNoResults: f,
					canRefine: !(f && m),
					refine: d.refine,
					sendEvent: d.sendEvent,
					widgetParams: n
				};
			}
		};
	};
};
function Ve(e, t, n) {
	var r = e.getNumericRefinements(t);
	return n.start !== void 0 && n.end !== void 0 ? n.start === n.end ? J(r, "=", n.start) : J(r, ">=", n.start) && J(r, "<=", n.end) : n.start === void 0 ? n.end === void 0 ? n.start === void 0 && n.end === void 0 ? Object.keys(r).every(function(e) {
		return (r[e] || []).length === 0;
	}) : !1 : J(r, "<=", n.end) : J(r, ">=", n.start);
}
function He(e, t, n) {
	var r = e, i = JSON.parse(decodeURI(n)), a = r.getNumericRefinements(t);
	if (i.start === void 0 && i.end === void 0) return r.removeNumericRefinement(t);
	if (Ve(r, t, i) || (r = r.removeNumericRefinement(t)), i.start !== void 0 && i.end !== void 0) {
		if (i.start > i.end) throw Error("option.start should be > to option.end");
		if (i.start === i.end) return r = J(a, "=", i.start) ? r.removeNumericRefinement(t, "=", i.start) : r.addNumericRefinement(t, "=", i.start), r;
	}
	return i.start !== void 0 && (J(a, ">=", i.start) && (r = r.removeNumericRefinement(t, ">=", i.start)), r = r.addNumericRefinement(t, ">=", i.start)), i.end !== void 0 && (J(a, "<=", i.end) && (r = r.removeNumericRefinement(t, "<=", i.end)), r = r.addNumericRefinement(t, "<=", i.end)), typeof r.page == "number" && (r.page = 0), r;
}
function J(e, t, n) {
	var r = e[t];
	return r !== void 0 && r.includes(n);
}
function Ue(e, t) {
	return e.numericMenu ? (e.numericMenu[t] === ":" && delete e.numericMenu[t], Object.keys(e.numericMenu).length === 0 && delete e.numericMenu, e) : e;
}
//#endregion
//#region node_modules/react-instantsearch-core/dist/es/connectors/useNumericMenu.js
function We(e, t) {
	return O(Be, e, t);
}
//#endregion
//#region node_modules/instantsearch.js/es/connectors/refinement-list/connectRefinementList.js
var Y = u({
	name: "refinement-list",
	connector: !0
}), Ge = [
	"isRefined",
	"count:desc",
	"name:asc"
], Ke = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : b;
	return d(e, Y()), function(n) {
		var r = n || {}, a = r.attribute, o = r.operator, c = o === void 0 ? "or" : o, l = r.limit, u = l === void 0 ? 10 : l, d = r.showMore, f = d === void 0 ? !1 : d, p = r.showMoreLimit, m = p === void 0 ? 20 : p, g = r.sortBy, _ = g === void 0 ? Ge : g, v = r.escapeFacetValues, y = v === void 0 ? !0 : v, b = r.transformItems, S = b === void 0 ? function(e) {
			return e;
		} : b;
		if (!a) throw Error(Y("The `attribute` option is required."));
		if (!/^(and|or)$/.test(c)) throw Error(Y(`The \`operator\` must one of: \`"and"\`, \`"or"\` (got "${c}").`));
		if (f === !0 && m <= u) throw Error(Y("`showMoreLimit` should be greater than `limit`."));
		var C = function(e) {
			var t = e.name, n = e.escapedValue;
			return I(k({}, s(e, ["name", "escapedValue"])), {
				value: n,
				label: t,
				highlighted: t
			});
		}, w, T = [], E = !0, D, O, A = !1, j = function() {};
		function M() {
			j();
		}
		function N(e, t) {
			return function() {
				A = !A, t.render(e);
			};
		}
		function P() {
			return A ? m : u;
		}
		var F = function() {
			return function() {};
		}, ee = function(t, n) {
			return function(r) {
				return function(o) {
					var c = r.instantSearchInstance, l = r.results;
					if (o === "" && T) e(I(k({}, n.getWidgetRenderState(I(k({}, r), { results: w }))), { instantSearchInstance: c }), !1);
					else {
						var u = {
							highlightPreTag: y ? z.highlightPreTag : h.highlightPreTag,
							highlightPostTag: y ? z.highlightPostTag : h.highlightPostTag
						};
						t.searchForFacetValues(a, o, Math.min(P(), 100), u).then(function(t) {
							var a = S((y ? i(t.facetHits) : t.facetHits).map(function(e) {
								var t = e.escapedValue, n = e.value;
								return I(k({}, s(e, ["escapedValue", "value"])), {
									value: t,
									label: n
								});
							}), { results: l });
							e(I(k({}, n.getWidgetRenderState(I(k({}, r), { results: w }))), {
								items: a,
								canToggleShowMore: !1,
								canRefine: !0,
								isFromSearch: !0,
								instantSearchInstance: c
							}), !1);
						});
					}
				};
			};
		};
		return {
			$$type: "ais.refinementList",
			init: function(t) {
				e(I(k({}, this.getWidgetRenderState(t)), { instantSearchInstance: t.instantSearchInstance }), !0);
			},
			render: function(t) {
				e(I(k({}, this.getWidgetRenderState(t)), { instantSearchInstance: t.instantSearchInstance }), !1);
			},
			getRenderState: function(e, t) {
				return I(k({}, e), { refinementList: I(k({}, e.refinementList), x({}, a, this.getWidgetRenderState(t))) });
			},
			getWidgetRenderState: function(e) {
				var t = this, r = e.results, i = e.state, o = e.createURL, s = e.instantSearchInstance, c = e.helper, l = [], d = [];
				if ((!O || !D || !F) && (O = me({
					instantSearchInstance: s,
					helper: c,
					attribute: a,
					widgetType: this.$$type
				}), D = function(e) {
					O("click:internal", e), c.toggleFacetRefinement(a, e).search();
				}, F = ee(c, this)), r) {
					var p = r.getFacetValues(a, {
						sortBy: _,
						facetOrdering: _ === Ge
					});
					d = p && Array.isArray(p) ? p : [], l = S(d.slice(0, P()).map(C), { results: r });
					var m = i.maxValuesPerFacet, h = P();
					E = m > h ? d.length <= h : d.length < h, w = r, T = l, e.results && (j = N(e, this));
				}
				var g = F && F(e), v = A && T.length > u || f && !E;
				return {
					createURL: function(e) {
						return o(function(n) {
							return t.getWidgetUiState(n, {
								searchParameters: i.resetPage().toggleFacetRefinement(a, e),
								helper: c
							});
						});
					},
					items: l,
					refine: D,
					searchForItems: g,
					isFromSearch: !1,
					canRefine: l.length > 0,
					widgetParams: n,
					isShowingMore: A,
					canToggleShowMore: v,
					toggleShowMore: M,
					sendEvent: O,
					hasExhaustiveItems: E
				};
			},
			dispose: function(e) {
				var n = e.state;
				t();
				var r = n.setQueryParameter("maxValuesPerFacet", void 0);
				return c === "and" ? r.removeFacet(a) : r.removeDisjunctiveFacet(a);
			},
			getWidgetUiState: function(e, t) {
				var n = t.searchParameters, r = c === "or" ? n.getDisjunctiveRefinements(a) : n.getConjunctiveRefinements(a);
				return qe(I(k({}, e), { refinementList: I(k({}, e.refinementList), x({}, a, r)) }), a);
			},
			getWidgetSearchParameters: function(e, t) {
				var n = t.uiState, r = c === "or";
				if (e.isHierarchicalFacet(a) || r && e.isConjunctiveFacet(a) || !r && e.isDisjunctiveFacet(a)) return e;
				var i = n.refinementList && n.refinementList[a], o = r ? e.addDisjunctiveFacet(a).removeDisjunctiveFacetRefinement(a) : e.addFacet(a).removeFacetRefinement(a), s = o.maxValuesPerFacet || 0, l = Math.max(s, f ? m : u), d = o.setQueryParameter("maxValuesPerFacet", l);
				if (!i) {
					var p = r ? "disjunctiveFacetsRefinements" : "facetsRefinements";
					return d.setQueryParameters(x({}, p, I(k({}, d[p]), x({}, a, []))));
				}
				return i.reduce(function(e, t) {
					return r ? e.addDisjunctiveFacetRefinement(a, t) : e.addFacetRefinement(a, t);
				}, d);
			}
		};
	};
};
function qe(e, t) {
	return e.refinementList ? ((!e.refinementList[t] || e.refinementList[t].length === 0) && delete e.refinementList[t], Object.keys(e.refinementList).length === 0 && delete e.refinementList, e) : e;
}
//#endregion
//#region node_modules/react-instantsearch-core/dist/es/connectors/useRefinementList.js
function Je(e, t) {
	return O(Ke, e, t);
}
//#endregion
//#region node_modules/instantsearch.js/es/connectors/sort-by/connectSortBy.js
var X = u({
	name: "sort-by",
	connector: !0
});
function Ye(e) {
	return "strategy" in e && e.strategy !== void 0;
}
function Xe(e) {
	return Ye(e) ? e.strategy : e.value;
}
function Ze(e, t) {
	if (!t) return !1;
	var n = e[t];
	return n !== void 0 && Ye(n);
}
var Qe = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : b;
	d(e, X());
	var n = {};
	return function(r) {
		var i = r || {}, a = i.items, o = i.transformItems, s = o === void 0 ? function(e) {
			return e;
		} : o;
		if (!Array.isArray(a)) throw Error(X("The `items` option expects an array of objects."));
		var c = {};
		return a.forEach(function(e, t) {
			var n = "value" in e && e.value !== void 0, r = "strategy" in e && e.strategy !== void 0;
			if (n && r) throw Error(X(`Item at index ${t} cannot have both "value" and "strategy" properties.`));
			if (!n && !r) throw Error(X(`Item at index ${t} must have either a "value" or "strategy" property.`));
			var i = Xe(e);
			c[i] = e;
		}), n.itemsLookup = c, {
			$$type: "ais.sortBy",
			init: function(t) {
				var n = t.instantSearchInstance;
				if (a.some(function(e) {
					return "strategy" in e && e.strategy;
				}) && !n.compositionID) throw Error(X("Sorting strategies can only be used in composition mode. Please provide a \"compositionID\" to your InstantSearch instance."));
				var r = this.getWidgetRenderState(t), i = r.currentRefinement;
				p(a, function(e) {
					return Xe(e) === i;
				}), e(I(k({}, r), { instantSearchInstance: n }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance;
				e(I(k({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !1);
			},
			dispose: function(e) {
				var r = e.state;
				return t(), n.isUsingComposition && r.sortBy && (r = r.setQueryParameter("sortBy", void 0)), n.initialValue && r.index !== n.initialValue ? r.setIndex(n.initialValue) : r;
			},
			getRenderState: function(e, t) {
				return I(k({}, e), { sortBy: this.getWidgetRenderState(t) });
			},
			getWidgetRenderState: function(e) {
				var t = e.results, i = e.helper, o = e.state, c = e.parent, l = e.instantSearchInstance;
				!n.initialValue && c && (n.initialValue = c.getIndexName()), n.refine ||= (n.isUsingComposition = !!l?.compositionID, function(e) {
					var t = n.itemsLookup[e];
					t && Ye(t) ? i.setQueryParameter("sortBy", t.strategy).search() : i.setQueryParameter("sortBy", void 0).setIndex(e).search();
				});
				var u = s(a, { results: t }).map(function(e) {
					return {
						label: e.label,
						value: Xe(e)
					};
				}), d = n.isUsingComposition && Ze(n.itemsLookup, o.sortBy) ? o.sortBy : o.index, f = t ? t.nbHits === 0 : !0;
				return {
					currentRefinement: d,
					options: u,
					refine: n.refine,
					hasNoResults: f,
					canRefine: !f && a.length > 0,
					widgetParams: r
				};
			},
			getWidgetUiState: function(e, t) {
				var r = t.searchParameters, i = n.isUsingComposition && Ze(n.itemsLookup, r.sortBy) ? r.sortBy : r.index;
				return I(k({}, e), { sortBy: i === n.initialValue ? void 0 : i });
			},
			getWidgetSearchParameters: function(e, t) {
				var r = t.uiState, i = (!r.sortBy || Object.prototype.hasOwnProperty.call(n.itemsLookup, r.sortBy) ? r.sortBy : void 0) || n.initialValue || e.index;
				if (Ze(n.itemsLookup, i)) {
					var a = n.itemsLookup[i];
					return e.setQueryParameter("sortBy", a.strategy);
				}
				return e.setQueryParameter("index", i);
			}
		};
	};
};
//#endregion
//#region node_modules/react-instantsearch-core/dist/es/connectors/useSortBy.js
function $e(e, t) {
	return O(Qe, e, t);
}
//#endregion
//#region node_modules/instantsearch.js/es/connectors/stats/connectStats.js
var et = u({
	name: "stats",
	connector: !0
}), tt = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : b;
	return d(e, et()), function(n) {
		return {
			$$type: "ais.stats",
			init: function(t) {
				var n = t.instantSearchInstance;
				e(I(k({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance;
				e(I(k({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !1);
			},
			dispose: function() {
				t();
			},
			getRenderState: function(e, t) {
				return I(k({}, e), { stats: this.getWidgetRenderState(t) });
			},
			getWidgetRenderState: function(e) {
				var t = e.results, r = e.state;
				return t ? {
					hitsPerPage: t.hitsPerPage,
					nbHits: t.nbHits,
					nbSortedHits: t.nbSortedHits,
					areHitsSorted: t.appliedRelevancyStrictness !== void 0 && t.appliedRelevancyStrictness > 0 && t.nbSortedHits !== t.nbHits,
					nbPages: t.nbPages,
					page: t.page,
					processingTimeMS: t.processingTimeMS,
					query: t.query,
					widgetParams: n
				} : {
					hitsPerPage: r.hitsPerPage,
					nbHits: 0,
					nbSortedHits: void 0,
					areHitsSorted: !1,
					nbPages: 0,
					page: r.page || 0,
					processingTimeMS: -1,
					query: r.query || "",
					widgetParams: n
				};
			}
		};
	};
};
//#endregion
//#region node_modules/react-instantsearch-core/dist/es/connectors/useStats.js
function nt(e, t) {
	return O(tt, e, t);
}
//#endregion
//#region node_modules/instantsearch.js/es/connectors/toggle-refinement/connectToggleRefinement.js
var rt = u({
	name: "toggle-refinement",
	connector: !0
}), it = "ais.toggleRefinement", at = function(e) {
	var t = e.instantSearchInstance, n = e.helper, r = e.attribute, i = e.on;
	return function() {
		var e = [...arguments];
		if (e.length === 1) {
			t.sendEventToInsights(e[0]);
			return;
		}
		var a = M(e, 3), o = a[1], s = a[2], c = s === void 0 ? "Filter Applied" : s, l = M(e[0].split(":"), 2), u = l[0], d = l[1];
		!(u !== "click" || i === void 0) && !o && t.sendEventToInsights({
			insightsMethod: "clickedFilters",
			widgetType: it,
			eventType: u,
			eventModifier: d,
			payload: {
				eventName: c,
				index: n.lastResults?.index || n.state.index,
				filters: i.map(function(e) {
					return `${r}:${e}`;
				})
			},
			attribute: r
		});
	};
}, ot = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : b;
	return d(e, rt()), function(n) {
		var r = n || {}, i = r.attribute, a = r.on, o = a === void 0 ? !0 : a, s = r.off;
		if (!i) throw Error(rt("The `attribute` option is required."));
		var c = s !== void 0, l = G(o).map(U), u = c ? G(s).map(U) : void 0, d, f = function(e) {
			return function() {
				var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : { isRefined: !1 }).isRefined;
				t ? (l.forEach(function(t) {
					return e.removeDisjunctiveFacetRefinement(i, t);
				}), c && u.forEach(function(t) {
					return e.addDisjunctiveFacetRefinement(i, t);
				})) : (d("click:internal", t), c && u.forEach(function(t) {
					return e.removeDisjunctiveFacetRefinement(i, t);
				}), l.forEach(function(t) {
					return e.addDisjunctiveFacetRefinement(i, t);
				})), e.search();
			};
		}, m = { createURLFactory: function(e, t) {
			var n = t.state, r = t.createURL, a = t.getWidgetUiState, o = t.helper;
			return function() {
				n = n.resetPage();
				var t = e ? l : u;
				t && t.forEach(function(e) {
					n = n.removeDisjunctiveFacetRefinement(i, e);
				});
				var s = e ? u : l;
				return s && s.forEach(function(e) {
					n = n.addDisjunctiveFacetRefinement(i, e);
				}), r(function(e) {
					return a(e, {
						searchParameters: n,
						helper: o
					});
				});
			};
		} };
		return {
			$$type: it,
			init: function(t) {
				var n = t.instantSearchInstance;
				e(I(k({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance;
				e(I(k({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !1);
			},
			dispose: function(e) {
				var n = e.state;
				return t(), n.removeDisjunctiveFacet(i);
			},
			getRenderState: function(e, t) {
				return I(k({}, e), { toggleRefinement: I(k({}, e.toggleRefinement), x({}, i, this.getWidgetRenderState(t))) });
			},
			getWidgetRenderState: function(e) {
				var t = e.state, r = e.helper, a = e.results, o = e.createURL, s = e.instantSearchInstance, h = l.every(function(e) {
					return t.isDisjunctiveFacetRefined(i, e);
				}), g = {
					isRefined: h,
					count: 0
				}, _ = {
					isRefined: c && !h,
					count: 0
				};
				if (a) {
					var v = G(u || !1), y = a.getFacetValues(i, {}) || [], b = l.map(function(e) {
						return p(y, function(t) {
							return t.escapedValue === U(String(e));
						});
					}).filter(function(e) {
						return e !== void 0;
					}), x = c ? v.map(function(e) {
						return p(y, function(t) {
							return t.escapedValue === U(String(e));
						});
					}).filter(function(e) {
						return e !== void 0;
					}) : [];
					g = {
						isRefined: b.length ? b.every(function(e) {
							return e.isRefined;
						}) : !1,
						count: b.reduce(function(e, t) {
							return e + t.count;
						}, 0) || null
					}, _ = {
						isRefined: x.length ? x.every(function(e) {
							return e.isRefined;
						}) : !1,
						count: x.reduce(function(e, t) {
							return e + t.count;
						}, 0) || y.reduce(function(e, t) {
							return e + t.count;
						}, 0)
					};
				}
				d ||= at({
					instantSearchInstance: s,
					attribute: i,
					on: l,
					helper: r
				});
				var S = h ? _ : g;
				return {
					value: {
						name: i,
						isRefined: h,
						count: a ? S.count : null,
						onFacetValue: g,
						offFacetValue: _
					},
					createURL: m.createURLFactory(h, {
						state: t,
						createURL: o,
						helper: r,
						getWidgetUiState: this.getWidgetUiState
					}),
					sendEvent: d,
					canRefine: !!(a && S.count),
					refine: f(r),
					widgetParams: n
				};
			},
			getWidgetUiState: function(e, t) {
				var n = t.searchParameters, r = l && l.every(function(e) {
					return n.isDisjunctiveFacetRefined(i, e);
				});
				if (!r) {
					var a;
					return (a = e.toggle) == null || delete a[i], e;
				}
				return I(k({}, e), { toggle: I(k({}, e.toggle), x({}, i, r)) });
			},
			getWidgetSearchParameters: function(e, t) {
				var n = t.uiState;
				if (e.isHierarchicalFacet(i) || e.isConjunctiveFacet(i)) return e;
				var r = e.addDisjunctiveFacet(i).removeDisjunctiveFacetRefinement(i);
				return n.toggle && n.toggle[i] ? (l && l.forEach(function(e) {
					r = r.addDisjunctiveFacetRefinement(i, e);
				}), r) : c ? (u && u.forEach(function(e) {
					r = r.addDisjunctiveFacetRefinement(i, e);
				}), r) : r.setQueryParameters({ disjunctiveFacetsRefinements: I(k({}, e.disjunctiveFacetsRefinements), x({}, i, [])) });
			}
		};
	};
};
//#endregion
//#region node_modules/react-instantsearch-core/dist/es/connectors/useToggleRefinement.js
function st(e, t) {
	return O(ot, e, t);
}
//#endregion
//#region node_modules/react-instantsearch/dist/es/ui/InfiniteHits.js
t();
function ct(e) {
	var t = e.hit;
	return /*#__PURE__*/ _.createElement("div", { style: { wordBreak: "break-all" } }, JSON.stringify(t).slice(0, 100), "…");
}
function lt(e) {
	var t = e.classNames, n = e.banner;
	return n.image.urls[0].url ? /*#__PURE__*/ _.createElement("aside", { className: A("ais-InfiniteHits-banner", t.bannerRoot) }, n.link ? /*#__PURE__*/ _.createElement("a", {
		className: A("ais-InfiniteHits-banner-link", t.bannerLink),
		href: n.link.url,
		target: n.link.target
	}, /*#__PURE__*/ _.createElement("img", {
		className: A("ais-InfiniteHits-banner-image", t.bannerImage),
		src: n.image.urls[0].url,
		alt: n.image.title
	})) : /*#__PURE__*/ _.createElement("img", {
		className: A("ais-InfiniteHits-banner-image", t.bannerImage),
		src: n.image.urls[0].url,
		alt: n.image.title
	})) : null;
}
function ut(e) {
	var t = e.hitComponent, n = t === void 0 ? ct : t, r = e.hits, i = e.bannerComponent, a = e.banner, o = e.sendEvent, c = e.isFirstPage, l = e.isLastPage, u = e.onShowPrevious, d = e.onShowMore, f = e.classNames, p = f === void 0 ? {} : f, m = e.translations, h = s(e, [
		"hitComponent",
		"hits",
		"bannerComponent",
		"banner",
		"sendEvent",
		"isFirstPage",
		"isLastPage",
		"onShowPrevious",
		"onShowMore",
		"classNames",
		"translations"
	]);
	return /*#__PURE__*/ _.createElement("div", I(k({}, h), { className: A("ais-InfiniteHits", p.root, r.length === 0 && A("ais-InfiniteHits--empty", p.emptyRoot), h.className) }), u && /*#__PURE__*/ _.createElement("button", {
		className: A("ais-InfiniteHits-loadPrevious", p.loadPrevious, c && A("ais-InfiniteHits-loadPrevious--disabled", p.disabledLoadPrevious)),
		onClick: u,
		disabled: c
	}, m.showPreviousButtonText), a && (i ? /*#__PURE__*/ _.createElement(i, {
		className: A("ais-InfiniteHits-banner", p.bannerRoot),
		banner: a
	}) : /*#__PURE__*/ _.createElement(lt, {
		classNames: p,
		banner: a
	})), /*#__PURE__*/ _.createElement("ol", { className: A("ais-InfiniteHits-list", p.list) }, r.map(function(e) {
		return /*#__PURE__*/ _.createElement("li", {
			key: e.objectID,
			className: A("ais-InfiniteHits-item", p.item),
			onClick: function() {
				o("click:internal", e, "Hit Clicked");
			},
			onAuxClick: function() {
				o("click:internal", e, "Hit Clicked");
			}
		}, /*#__PURE__*/ _.createElement(n, {
			hit: e,
			sendEvent: o
		}));
	})), /*#__PURE__*/ _.createElement("button", {
		className: A("ais-InfiniteHits-loadMore", p.loadMore, l && A("ais-InfiniteHits-loadMore--disabled", p.disabledLoadMore)),
		onClick: d,
		disabled: l
	}, m.showMoreButtonText));
}
//#endregion
//#region node_modules/react-instantsearch/dist/es/widgets/InfiniteHits.js
t();
function dt(e) {
	var t = e.showPrevious, n = t === void 0 ? !0 : t, r = e.cache, i = e.escapeHTML, a = e.transformItems, o = e.translations, c = e.bannerComponent, l = s(e, [
		"showPrevious",
		"cache",
		"escapeHTML",
		"transformItems",
		"translations",
		"bannerComponent"
	]), u = Ie({
		cache: r,
		escapeHTML: i,
		showPrevious: n,
		transformItems: a
	}, { $$widgetType: "ais.infiniteHits" }), d = u.items, f = u.banner, p = u.sendEvent, m = u.showPrevious, h = u.showMore, g = u.isFirstPage, v = u.isLastPage, y = {
		hits: d,
		banner: f,
		bannerComponent: c === !1 ? function() {
			return null;
		} : c,
		sendEvent: p,
		onShowPrevious: n ? m : void 0,
		onShowMore: h,
		isFirstPage: g,
		isLastPage: v,
		translations: k({
			showPreviousButtonText: "Show previous results",
			showMoreButtonText: "Show more results"
		}, o)
	};
	return /*#__PURE__*/ _.createElement(ut, k({}, l, y));
}
//#endregion
//#region node_modules/react-instantsearch/dist/es/ui/SortBy.js
t();
function ft(e) {
	var t = e.items, n = e.value, r = e.onChange, i = r === void 0 ? function() {} : r, a = e.classNames, o = a === void 0 ? {} : a, c = s(e, [
		"items",
		"value",
		"onChange",
		"classNames"
	]);
	return /*#__PURE__*/ _.createElement("div", I(k({}, c), { className: A("ais-SortBy", o.root, c.className) }), /*#__PURE__*/ _.createElement("select", {
		className: A("ais-SortBy-select", o.select),
		onChange: function(e) {
			return i(e.target.value);
		},
		value: n,
		"aria-label": "Sort results by"
	}, t.map(function(e) {
		return /*#__PURE__*/ _.createElement("option", {
			className: A("ais-SortBy-option", o.option),
			key: e.value,
			value: e.value
		}, e.label);
	})));
}
//#endregion
//#region node_modules/react-instantsearch/dist/es/widgets/SortBy.js
t();
function pt(e) {
	var t = e.items, n = e.transformItems, r = s(e, ["items", "transformItems"]), i = $e({
		items: t,
		transformItems: n
	}, { $$widgetType: "ais.sortBy" }), a = i.currentRefinement, o = {
		items: i.options,
		value: a,
		onChange: i.refine
	};
	return /*#__PURE__*/ _.createElement(ft, k({}, r, o));
}
//#endregion
//#region src/lib/search/swatches.ts
t();
var mt = null;
async function ht() {
	let e = await ee("", { body: {
		query: de,
		variables: { first: 250 }
	} }), t = /* @__PURE__ */ new Map();
	for (let n of e?.metaobjects?.nodes ?? []) {
		let e = n.label?.value;
		if (!e) continue;
		let r = n.image?.reference?.image?.url;
		t.set(e, {
			color: n.color?.value ?? null,
			imageUrl: typeof r == "string" ? r : null
		});
	}
	return t;
}
function gt() {
	return mt ||= ht().catch((e) => (console.error("Failed to fetch color pattern swatches", e), mt = null, /* @__PURE__ */ new Map())), mt;
}
function _t() {
	let [e, t] = o(() => /* @__PURE__ */ new Map());
	return l(() => {
		let e = !1;
		return gt().then((n) => {
			e || t(n);
		}), () => {
			e = !0;
		};
	}, []), e;
}
//#endregion
//#region src/lib/search/Filters.tsx
t();
var vt = [{
	attribute: "meta.custom.available_for_next_day_shipping",
	label: window.generalStrings.search.filters.nextDayShipping
}, {
	attribute: "meta.custom.available_for_shipping",
	label: window.generalStrings.search.filters.availableOnline
}];
function yt(e) {
	let { value: t, refine: n } = st(e);
	return /* @__PURE__ */ N("div", {
		className: "border-b-brand-light grid grid-cols-1 border-b",
		children: /* @__PURE__ */ N("div", {
			className: "group/switch flex flex-row-reverse items-center justify-between",
			children: [/* @__PURE__ */ N("div", {
				className: "relative inline-block h-6 w-11 shrink-0 cursor-pointer rounded-full",
				children: [/* @__PURE__ */ N("input", {
					type: "checkbox",
					className: "peer disabled:bg-brand-light bg-brand-neutral checked:bg-brand-darkest checked:disabled:bg-brand-dark peer-checked:border-brand-neutral peer-checked:before:bg-neutral absolute h-full w-full cursor-pointer appearance-none rounded-full transition-colors duration-300 disabled:cursor-not-allowed",
					checked: t.isRefined,
					onChange: (e) => {
						n({ isRefined: !e.target.checked });
					},
					name: e.attribute,
					id: e.attribute
				}), /* @__PURE__ */ N("label", {
					className: "before:content[''] border-brand-neutral peer-disabled:bg-neutral before:bg-blue-gray-500 peer-checked:border-brand-neutral peer-checked:before:bg-neutral absolute top-2/4 left-0.5 h-5 w-5 -translate-y-2/4 cursor-pointer rounded-full border border-none bg-white shadow-md transition-all duration-300 peer-checked:translate-x-full before:absolute before:top-2/4 before:left-2/4 before:hidden before:h-5 before:w-10 before:-translate-x-2/4 before:-translate-y-2/4 before:rounded-full before:opacity-0 before:transition-opacity hover:before:opacity-10",
					htmlFor: e.attribute,
					children: /* @__PURE__ */ N("span", {
						className: "sr-only",
						children: e.label
					})
				})]
			}), /* @__PURE__ */ N("label", {
				className: "mt-px w-full cursor-pointer py-4 select-none",
				htmlFor: e.attribute,
				children: e.label
			})]
		})
	});
}
var bt = [
	{
		attribute: "vendor",
		label: window.generalStrings.search.filters.brand,
		limit: 100
	},
	{
		attribute: "meta.custom.family",
		label: window.generalStrings.search.filters.collection,
		limit: 500
	},
	{
		attribute: "meta.custom.case_size",
		label: window.generalStrings.search.filters.caseSize,
		numeric: !0
	},
	{
		attribute: "meta.shopify.dial-color.fields.label",
		label: window.generalStrings.search.filters.dialColor
	},
	{
		attribute: "meta.shopify.case-color.fields.label",
		label: window.generalStrings.search.filters.caseColor
	},
	{
		attribute: "meta.shopify.band-color.fields.label",
		label: window.generalStrings.search.filters.bandColor
	},
	{
		attribute: "meta.shopify.watch-material.fields.label",
		label: window.generalStrings.search.filters.materials
	},
	{
		attribute: "meta.custom.case_material",
		label: window.generalStrings.search.filters.caseMaterial
	},
	{
		attribute: "meta.shopify.watch-features.fields.label",
		label: window.generalStrings.search.filters.features
	},
	{
		attribute: "meta.custom.water_resistance",
		label: window.generalStrings.search.filters.waterResistance,
		numeric: !0
	},
	{
		attribute: "meta.custom.gender",
		label: window.generalStrings.search.filters.gender
	}
], xt = [
	"Rolex CPO",
	"Patek Philippe",
	"Cartier",
	"OMEGA",
	"TAG Heuer",
	"TUDOR",
	"Breitling",
	"Grand Seiko",
	"Longines",
	"IWC Schaffhausen",
	"Oris"
];
function St(e, t) {
	let n = xt.indexOf(e.name), r = xt.indexOf(t.name);
	return n !== -1 && r !== -1 ? n - r : n === -1 ? r === -1 ? e.name.localeCompare(t.name) : 1 : -1;
}
function Ct(e, t) {
	let n = parseInt(e.name, 10), r = parseInt(t.name, 10);
	return isNaN(n) && isNaN(r) ? e.name.localeCompare(t.name) : isNaN(n) ? -1 : isNaN(r) ? 1 : n - r;
}
function wt(e) {
	let { items: t, refine: n, canToggleShowMore: r, isShowingMore: i, toggleShowMore: a, searchForItems: s } = Je(e), { items: c } = q({ includedAttributes: [e.attribute] }), u = _t(), d = e.attribute.includes("color"), f = e.attribute === "vendor", [p, m] = o(""), [h, g] = o(null);
	if (l(() => {
		f && !p && g(t.length);
	}, [
		f,
		t,
		p
	]), t.length === 0 && !f) return null;
	let _ = c[0]?.refinements.length ?? 0, v = f && (h === null || h >= 10), y = f && p.length > 0 && t.length === 0;
	return /* @__PURE__ */ N("div", {
		className: "border-b-brand-light flex flex-col border-b",
		children: [
			/* @__PURE__ */ N("h3", {
				className: "p mb-2",
				children: [e.label, _ > 0 ? ` (${_} ${window.generalStrings.search.filtersAppliedWord})` : ""]
			}),
			v && /* @__PURE__ */ N("div", {
				className: "mr-2 mb-2",
				children: /* @__PURE__ */ N("input", {
					type: "search",
					autoComplete: "off",
					autoCorrect: "off",
					autoCapitalize: "off",
					spellCheck: !1,
					maxLength: 512,
					onChange: (e) => {
						let t = e.currentTarget.value;
						m(t), s(t);
					},
					className: "border-brand-light placeholder:text-brand-dark w-full rounded border px-2 py-1 text-sm",
					placeholder: window.generalStrings.search.filters.searchBrandsPlaceholder
				})
			}),
			y && /* @__PURE__ */ N("p", {
				className: "p text-brand-dark px-2 py-1",
				children: window.generalStrings.search.filters.noMatchingBrands
			}),
			!y && /* @__PURE__ */ N("ul", {
				className: "scroll-shadows flex max-h-80 flex-col overflow-auto pl-2",
				children: t.map((e) => {
					let t = d ? u.get(e.label) : null, i = f && e.label.includes("Rolex CPO") ? window.generalStrings.search.rolexCpoLabel : e.label;
					return /* @__PURE__ */ N("li", {
						className: `flex ${r ? "" : "last:mb-2.5"}`,
						children: /* @__PURE__ */ N("label", {
							className: `hover:text-brand-darker flex cursor-pointer items-center gap-2 py-1 ${e.isRefined ? "text-brand-darkest" : "text-brand-dark"}`,
							children: [
								d && /* @__PURE__ */ N("span", {
									className: `border-brand-light inline-block h-4 w-4 shrink-0 rounded-full border bg-cover bg-center ${e.isRefined ? "ring-brand-darkest ring ring-offset-2" : ""}`,
									style: t?.imageUrl ? { backgroundImage: `url(${t.imageUrl})` } : { backgroundColor: t?.color ?? e.label }
								}),
								/* @__PURE__ */ N("input", {
									type: "checkbox",
									className: `${d ? "sr-only" : "accent-brand-dark-warm size-4 cursor-pointer"}`,
									checked: e.isRefined,
									onChange: () => n(e.value)
								}),
								/* @__PURE__ */ N("span", {
									className: "p",
									children: i
								})
							]
						})
					}, e.label);
				})
			}),
			/* @__PURE__ */ N("button", {
				onClick: a,
				disabled: !r,
				className: r ? "utility-mini mt-2 mb-4 ml-2 w-fit underline" : "hidden",
				children: i ? "Show less" : "Show more"
			})
		]
	});
}
var Tt = "price", Et = [
	{ label: "All" },
	{
		label: "Less than $500",
		end: 500
	},
	{
		label: "Between $500 - $1,000",
		start: 500,
		end: 1e3
	},
	{
		label: "Between $1,000 - $5,000",
		start: 1e3,
		end: 5e3
	},
	{
		label: "Between $5,000 - $10,000",
		start: 5e3,
		end: 1e4
	},
	{
		label: "More than $10,000",
		start: 1e4
	}
];
function Dt(e) {
	let { items: t, refine: n } = We(e);
	return /* @__PURE__ */ N("div", { children: [/* @__PURE__ */ N("h3", {
		className: "p mb-2",
		children: window.generalStrings.search.filters.price
	}), /* @__PURE__ */ N("ul", {
		className: "flex flex-col pl-2",
		children: t.map((e) => /* @__PURE__ */ N("li", { children: /* @__PURE__ */ N("label", {
			className: `hover:text-brand-darker flex cursor-pointer items-center gap-2 py-1 ${e.isRefined ? "text-brand-darkest" : "text-brand-dark"}`,
			children: [/* @__PURE__ */ N("input", {
				className: "accent-brand-accent size-4 cursor-pointer",
				type: "radio",
				checked: e.isRefined,
				onChange: (t) => {
					t.preventDefault(), n(e.value);
				}
			}), /* @__PURE__ */ N("span", {
				className: "p",
				children: e.label
			})]
		}) }, e.value))
	})] });
}
var Ot = () => /* @__PURE__ */ N("div", {
	className: "flex flex-col gap-4 pb-14 lg:pb-4",
	children: [
		/* @__PURE__ */ N("div", { children: vt.map(({ attribute: e, label: t }) => /* @__PURE__ */ N(yt, {
			attribute: e,
			label: t
		}, e)) }),
		bt.map(({ attribute: e, label: t, limit: n, numeric: r }) => /* @__PURE__ */ N(wt, {
			attribute: e,
			showMore: !(n !== void 0 && n <= n),
			showMoreLimit: 100,
			limit: n ?? 4,
			sortBy: r ? Ct : e === "vendor" ? St : ["name:asc"],
			label: t
		})),
		/* @__PURE__ */ N(Dt, {
			attribute: Tt,
			items: Et
		})
	]
});
//#endregion
//#region src/lib/search/PagesResults.tsx
function kt() {
	return /* @__PURE__ */ N("div", {
		className: "mx-auto max-w-2xl p-8 text-center",
		children: [
			/* @__PURE__ */ N("h3", {
				className: "p mb-8",
				"aria-live": "assertive",
				children: window.generalStrings.search.noResultsFoundHeading
			}),
			/* @__PURE__ */ N("h4", {
				className: "h4 mb-4",
				children: window.generalStrings.search.needAssistance
			}),
			/* @__PURE__ */ N("div", {
				className: "rte mb-4 font-light",
				children: /* @__PURE__ */ N("p", { children: window.generalStrings.search.pagesEmptyHelp })
			})
		]
	});
}
function At({ pages: e }) {
	let { status: t } = R();
	return e.length === 0 ? t === "idle" ? /* @__PURE__ */ N(kt, {}) : null : /* @__PURE__ */ N("ul", {
		className: "px-safe-or-2 mx-auto flex max-w-3xl flex-col gap-6 py-8",
		children: e.map((e) => /* @__PURE__ */ N("li", {
			className: "border-b-brand-light border-b pb-6 last:border-b-0",
			children: /* @__PURE__ */ N("a", {
				href: e.url,
				className: "group/page block",
				children: [
					/* @__PURE__ */ N("h3", {
						className: "h6 mb-3",
						children: e.title.split(" | ")[0]
					}),
					e.description && /* @__PURE__ */ N("p", {
						className: "p-mini text-brand-darkest font-light",
						children: e.description
					}),
					/* @__PURE__ */ N("span", {
						className: "p-mini text-brand-darkest group-hover/page:text-brand-dark mt-2 block font-light underline transition-colors",
						"aria-hidden": "true",
						children: window.generalStrings.search.readMoreLink
					})
				]
			})
		}, e.objectID))
	});
}
//#endregion
//#region src/lib/search/ProductResults.tsx
y();
function jt() {
	let { nbHits: e } = nt();
	return /* @__PURE__ */ N("span", { children: [
		e.toLocaleString(),
		" ",
		window.generalStrings.search.resultsCountLabel
	] });
}
var Mt = [
	{
		label: window.generalStrings.search.sort.relevance,
		value: "shopify_products"
	},
	{
		label: window.generalStrings.search.sort.priceAscending,
		value: "shopify_products_price_asc"
	},
	{
		label: window.generalStrings.search.sort.priceDescending,
		value: "shopify_products_price_desc"
	}
], Nt = () => /* @__PURE__ */ N(pt, {
	items: Mt,
	classNames: {
		root: "shrink-0 relative after:content-[\"\"] after:absolute after:right-3 after:top-1/2 after:-translate-y-1 after:h-1.5 after:w-1.5 after:rotate-45 after:border-r after:border-b after:border-current",
		select: "rounded-xs border border-brand-lightest bg-brand-lightest px-3 py-2 pr-6 text-sm appearance-none cursor-pointer w-full"
	}
});
function Pt(e) {
	let { items: t } = q(e), { refine: n, canRefine: r } = K(e);
	return r ? /* @__PURE__ */ N("button", {
		onClick: n,
		className: "btn btn--pill px-2 py-0.5 text-xs md:px-3 md:py-1.5 md:text-sm",
		children: [
			window.generalStrings.search.clear,
			" (",
			t.length,
			")"
		]
	}) : null;
}
function Ft(e) {
	let { items: t } = q(e), { refine: n, canRefine: r } = K(e);
	return /* @__PURE__ */ N("button", {
		onClick: n,
		className: "btn btn--secondary w-full",
		disabled: !r,
		children: [
			window.generalStrings.search.clearFilters,
			" (",
			t.length,
			")"
		]
	});
}
function It() {
	let { refine: e, canRefine: t } = K();
	return /* @__PURE__ */ N("div", {
		className: "mx-auto max-w-2xl flex-1 p-8 text-center",
		children: [
			/* @__PURE__ */ N("h3", {
				className: "p mb-8",
				"aria-live": "assertive",
				children: window.generalStrings.search.noProductsFound
			}),
			/* @__PURE__ */ N("h4", {
				className: "h4 mb-4",
				children: window.generalStrings.search.tryAdjustingSearch
			}),
			/* @__PURE__ */ N("div", {
				className: "rte mb-4 font-light",
				children: /* @__PURE__ */ N("p", { children: window.generalStrings.search.productsEmptyHelp })
			}),
			t && /* @__PURE__ */ N("button", {
				onClick: e,
				className: "btn btn--secondary",
				children: window.generalStrings.search.clearFilters
			})
		]
	});
}
function Lt() {
	let { status: e } = R();
	return /* @__PURE__ */ N("span", {
		"data-products-status": e,
		className: "hidden"
	});
}
function Rt() {
	return /* @__PURE__ */ N(c, { children: /* @__PURE__ */ N("div", {
		className: "group/collection 3xl:mx-auto 3xl:max-w-[1792px]",
		children: [/* @__PURE__ */ N("div", {
			className: "px-safe-or-2 lg:px-safe-or-4 linear sticky top-[calc(var(--header-height)-1px)] z-30 flex items-center justify-between bg-white py-2.5 transition-[top] duration-200",
			children: [/* @__PURE__ */ N("p", {
				className: "caption text-brand-dark text-sm",
				children: /* @__PURE__ */ N(jt, {})
			}), /* @__PURE__ */ N("div", {
				className: "flex items-center gap-2",
				children: [/* @__PURE__ */ N("div", {
					className: "flex items-center gap-2 lg:hidden",
					children: [
						/* @__PURE__ */ N(Pt, {}),
						/* @__PURE__ */ N("dialog-toggle", {
							"modal-id": "filter-drawer-dialog",
							className: "inline-flex place-items-center",
							children: /* @__PURE__ */ N("button", {
								className: "p toggle-filter-button flex items-center gap-2.5 lg:gap-1.25",
								children: [/* @__PURE__ */ N("svg-icon", { src: "icon-filter" }), window.generalStrings.search.filterAndSort]
							})
						}),
						/* @__PURE__ */ N("modal-dialog", {
							"needs-script": "dialog",
							type: "drawer",
							id: "filter-drawer-dialog",
							className: "group/modal-dialog absolute z-50",
							anchor: "left",
							"close-on-backdrop-click": "true",
							"header-classes": "bg-white",
							"lock-dialog-scroll": "true",
							"custom-grid": "drawer pl-safe-or-0 grid grid-cols-1 grid-rows-[var(--dmn-dialog-header-height,60px)_minmax(0,1fr)] overflow-hidden! bg-white",
							"brand-style": "wos",
							children: [/* @__PURE__ */ N("h5", {
								slot: "header",
								className: "h6",
								children: window.generalStrings.search.filterAndSort
							}), /* @__PURE__ */ N("div", {
								className: "group/filters-form flex h-full",
								children: /* @__PURE__ */ N("div", {
									className: "flex w-full flex-col",
									children: [/* @__PURE__ */ N("div", {
										className: "px-safe-or-4 overflow-y-auto",
										children: [/* @__PURE__ */ N("div", {
											className: "border-b-brand-light flex items-center gap-2 border-0 border-b pb-4",
											children: [/* @__PURE__ */ N("span", {
												className: "caption text-brand-dark text-sm",
												children: window.generalStrings.search.sortBy
											}), /* @__PURE__ */ N(Nt, {})]
										}), /* @__PURE__ */ N(Ot, {})]
									}), /* @__PURE__ */ N("div", {
										className: "border-t-brand-light grid w-full grid-cols-1 justify-center gap-2.5 border-t border-solid bg-white px-2.5 py-4 group-data-end-of-scroll/filters-form:border-t-0",
										children: [/* @__PURE__ */ N(Ft, {}), /* @__PURE__ */ N("button", {
											"close-modal": !0,
											className: "btn btn--primary w-full",
											children: window.generalStrings.search.showResultsButton
										})]
									})]
								})
							})]
						})
					]
				}), /* @__PURE__ */ N("div", {
					className: "hidden items-center gap-2 lg:flex",
					children: [/* @__PURE__ */ N("span", {
						className: "caption text-brand-dark text-sm",
						children: window.generalStrings.search.sortBy
					}), /* @__PURE__ */ N(Nt, {})]
				})]
			})]
		}), /* @__PURE__ */ N("div", {
			className: "group/products-hits relative flex",
			children: [
				/* @__PURE__ */ N(Lt, {}),
				/* @__PURE__ */ N("div", {
					className: "hidden w-full overflow-clip lg:block lg:w-[250px] 2xl:w-[25%]",
					children: /* @__PURE__ */ N("div", {
						className: "grid min-w-fit lg:pr-4",
						children: [/* @__PURE__ */ N("div", {
							className: "lg:pl-safe-or-4",
							children: /* @__PURE__ */ N("div", {
								className: "border-b-brand-light flex min-h-[52px] items-center justify-between border-b pb-4",
								children: [/* @__PURE__ */ N("h2", {
									className: "h6",
									children: window.generalStrings.search.filtersHeading
								}), /* @__PURE__ */ N(Pt, {})]
							})
						}), /* @__PURE__ */ N("div", {
							className: "w-full flex-1 overflow-y-auto px-4 pb-14 lg:pr-0 lg:pb-4",
							children: /* @__PURE__ */ N(Ot, {})
						})]
					})
				}),
				/* @__PURE__ */ N(dt, {
					hitComponent: F,
					showPrevious: !1,
					translations: { showMoreButtonText: window.generalStrings.search.loadMore },
					classNames: {
						root: "flex-1 group-has-[.ais-InfiniteHits--empty]/products-hits:hidden",
						list: "px-safe-or-0 mb-5 grid grid-cols-2 gap-x-2.5 gap-y-5 md:grid-cols-3 lg:px-safe-or-4 lg:gap-x-4 lg:gap-y-8 lg:pl-4 lg:grid-cols-3 3xl:grid-cols-4",
						loadMore: "btn btn--primary mx-auto mb-5 block",
						disabledLoadMore: "hidden"
					}
				}),
				/* @__PURE__ */ N("div", {
					className: "hidden flex-1 group-[&:has(.ais-InfiniteHits--empty):has([data-products-status='idle'])]/products-hits:block",
					children: /* @__PURE__ */ N(It, {})
				})
			]
		})]
	}) });
}
//#endregion
//#region src/lib/search/QuickResults.tsx
function zt({ hit: e }) {
	let t = V(e.url);
	return /* @__PURE__ */ N("a", {
		href: e.url,
		className: "btn btn--pill",
		children: [t == "store" ? /* @__PURE__ */ N("span", {
			className: "inline-flex items-center rounded-xs text-xs uppercase",
			children: [/* @__PURE__ */ N("span", {
				className: "sr-only",
				children: [t, ": "]
			}), /* @__PURE__ */ N("svg-icon", {
				src: "icon-pin",
				className: "size-4 fill-current"
			})]
		}) : "", /* @__PURE__ */ N("span", {
			className: "line-clamp-1",
			children: e.title.split(" | ")[0].split(", ")[0]
		})]
	});
}
var Bt = ({ types: e }) => /* @__PURE__ */ N("div", {
	className: "col-span-full mb-2 has-[.ais-Hits--empty]:hidden",
	children: /* @__PURE__ */ N(H, {
		indexName: "shopify_pages_and_metaobjects",
		children: [/* @__PURE__ */ N(se, {
			hitComponent: zt,
			classNames: {
				list: "relative mb-2 md:mb-4 px-safe-or-2 pb-2 pt-1 flex lg:flex-wrap overflow-auto lg:overflow-hidden items-center lg:justify-center gap-2 md:gap-4 w-full scrollbar-none overscroll-contain lg:overscroll-auto lg:max-w-4xl lg:mx-auto",
				item: "shrink-0"
			},
			transformItems: (t) => e ? t.filter((t) => e.includes(V(t.url))) : t
		}), /* @__PURE__ */ N(B, { hitsPerPage: 6 })]
	})
}), Z = null;
function Vt() {
	if (Z) return Z;
	let e = document.getElementById("storeInfoArray");
	if (!e?.textContent) return Z = [], Z;
	try {
		Z = JSON.parse(e.textContent);
	} catch (e) {
		console.error("Failed to parse store data", e), Z = [];
	}
	return Z;
}
function Ht(e, t) {
	let n = t.trim().toLowerCase();
	return n ? e.filter((e) => [e.title, e.store_address].filter((e) => !!e).some((e) => e.toLowerCase().includes(n))) : e;
}
function Ut(e) {
	if (!e) return "";
	let t = document.createElement("div");
	return t.innerHTML = e, t.querySelectorAll("br").forEach((e) => e.replaceWith("\n")), t.textContent ?? "";
}
function Wt(e) {
	if (!e) return "";
	let t = e.replace(/\D/g, ""), n = t.length === 11 && t.startsWith("1") ? t.slice(1) : t;
	return n.length === 10 ? `(${n.slice(0, 3)}) ${n.slice(3, 6)}-${n.slice(6)}` : e;
}
//#endregion
//#region src/lib/search/StoreCard.tsx
function Gt({ store: e }) {
	return /* @__PURE__ */ N("li", {
		className: "flex h-full flex-col justify-stretch overflow-hidden rounded-sm bg-white",
		children: [/* @__PURE__ */ N("a", {
			href: e.store_page,
			className: "bg-brand-light block aspect-video",
			children: [e.store_img ? /* @__PURE__ */ N("img", {
				src: e.store_img,
				alt: "",
				loading: "lazy",
				className: "aspect-video w-full object-cover"
			}) : /* @__PURE__ */ N("div", { className: "bg-brand-light aspect-video" }), /* @__PURE__ */ N("span", {
				className: "sr-only",
				children: e.title
			})]
		}), /* @__PURE__ */ N("div", {
			className: "grid grid-cols-2 gap-y-6 p-4",
			children: [/* @__PURE__ */ N("div", {
				className: "col-span-full flex flex-col gap-2.5",
				children: /* @__PURE__ */ N("h3", {
					className: "h5 text-left",
					children: [e.store_fascia && /* @__PURE__ */ N("span", {
						className: "utility block uppercase",
						children: e.store_fascia
					}), /* @__PURE__ */ N("a", {
						href: e.store_page,
						className: "text-left text-balance",
						children: e.title
					})]
				})
			}), /* @__PURE__ */ N("div", {
				className: "col-span-full grid grid-cols-2 gap-x-5 gap-y-3.5",
				children: [
					/* @__PURE__ */ N("div", {
						className: "flex flex-col gap-3",
						children: [/* @__PURE__ */ N("h4", {
							className: "utility-mini uppercase",
							children: window.generalStrings.search.storeContactLabel
						}), /* @__PURE__ */ N("div", {
							className: "text-brand-dark text-[0.815rem] leading-[1.3] font-light whitespace-pre-line",
							children: Ut(e.store_address)
						})]
					}),
					/* @__PURE__ */ N("div", {
						className: "col-span-full grid grid-cols-2 gap-x-3 text-xs",
						children: [e.store_number && /* @__PURE__ */ N("a", {
							className: "hover:text-brand-dark underline",
							href: `tel:${e.store_number}`,
							children: Wt(e.store_number)
						}), e.store_directions && /* @__PURE__ */ N("a", {
							className: "hover:text-brand-dark underline",
							href: e.store_directions,
							target: "_blank",
							rel: "noreferrer",
							children: window.generalStrings.search.storeGetDirections
						})]
					}),
					/* @__PURE__ */ N("a", {
						className: "btn bg-brand-lighter hover:bg-brand-light col-span-full mt-2 w-full",
						href: e.store_page,
						children: /* @__PURE__ */ N("span", { children: window.generalStrings.viewDetails })
					})
				]
			})]
		})]
	});
}
//#endregion
//#region src/lib/search/StoresResults.tsx
function Kt() {
	return /* @__PURE__ */ N("div", {
		className: "mx-auto max-w-2xl p-8 text-center",
		children: [
			/* @__PURE__ */ N("h3", {
				className: "p mb-8",
				"aria-live": "assertive",
				children: window.generalStrings.search.noResultsFoundHeading
			}),
			/* @__PURE__ */ N("h4", {
				className: "h4 mb-4",
				children: window.generalStrings.search.findAStore
			}),
			/* @__PURE__ */ N("div", {
				className: "rte mb-4 font-light",
				children: /* @__PURE__ */ N("p", { dangerouslySetInnerHTML: { __html: window.generalStrings.search.storesEmptyHelpHtml } })
			})
		]
	});
}
function qt({ stores: e }) {
	return e.length === 0 ? /* @__PURE__ */ N(Kt, {}) : /* @__PURE__ */ N("ul", {
		className: "px-safe-or-2 grid grid-cols-1 gap-5 pt-4 pb-8 md:grid-cols-2 lg:grid-cols-3",
		children: e.map((e) => /* @__PURE__ */ N(Gt, { store: e }, e.id))
	});
}
t(), y();
var Jt = new Set(vt.map((e) => e.attribute)), Yt = new Set(bt.map((e) => e.attribute));
function Xt(e) {
	return e === "products" || e === "pages" || e === "stores";
}
var { appId: Zt, searchKey: Qt, indexName: $t } = w, en = j(Zt, Qt), Q = D(), $ = "products", tn = Q.read();
Xt(tn?.tab) && ($ = tn.tab);
var nn = /* @__PURE__ */ new Set();
function rn(e) {
	$ = e, nn.forEach((t) => t(e));
}
function an() {
	let [e, t] = o($);
	return l(() => (nn.add(t), () => {
		nn.delete(t);
	}), []), [e, (e) => {
		e !== $ && (rn(e), Q.write({
			...Q.read(),
			tab: e
		}));
	}];
}
var on = {
	router: Q,
	stateMapping: {
		stateToRoute(e) {
			let t = e[$t], n = e[te], r = {
				...n?.refinementList,
				...n?.toggle,
				...n?.numericMenu
			};
			return {
				q: t?.query,
				filter: Object.keys(r).length > 0 ? r : void 0,
				sort: n?.sortBy,
				tab: $
			};
		},
		routeToState(e) {
			Xt(e.tab) && rn(e.tab);
			let t = {}, n = {}, r = {};
			for (let [i, a] of Object.entries(e.filter ?? {})) Jt.has(i) ? n[i] = a === !0 || a === "true" : i === "price" ? r[i] = a : Yt.has(i) && (t[i] = a);
			return {
				[$t]: { query: e.q },
				[te]: {
					refinementList: t,
					toggle: n,
					numericMenu: r,
					sortBy: e.sort
				}
			};
		}
	}
}, sn = [
	{
		id: "products",
		label: window.generalStrings.search.tabProducts
	},
	{
		id: "pages",
		label: window.generalStrings.search.tabPages
	},
	{
		id: "stores",
		label: window.generalStrings.search.tabStores
	}
];
function cn({ activeTab: e, onSelect: t, counts: n }) {
	return /* @__PURE__ */ N("div", {
		role: "tablist",
		className: "border-b-brand-light px-safe-or-2 flex justify-center gap-4 border-b",
		children: sn.map((r) => /* @__PURE__ */ N("button", {
			type: "button",
			role: "tab",
			"aria-selected": e === r.id,
			onClick: () => t(r.id),
			className: `p -mb-px border-b-2 px-1 pb-3 ${e === r.id ? "border-brand-accent text-brand-darkest" : "text-brand-dark border-transparent"}`,
			children: [
				r.label,
				" (",
				n[r.id],
				")"
			]
		}, r.id))
	});
}
function ln() {
	let { status: e } = R(), t = g(!1), n = g(!1);
	return l(() => {
		if (e === "loading" || e === "stalled") {
			t.current = !0;
			return;
		}
		if (e !== "idle" || !t.current || n.current) return;
		n.current = !0, document.getElementById("search-page-skeleton")?.remove(), document.getElementById("search-page")?.classList.remove("hidden");
		let r = document.querySelector("[data-search-page-input]");
		r && (r.focus(), r.setSelectionRange(0, r.value.length));
	}, [e]), null;
}
function un({ onChange: e }) {
	let { nbHits: t } = nt();
	return l(() => {
		e(t);
	}, [t, e]), null;
}
function dn({ onChange: e }) {
	let { items: t } = ce();
	return l(() => {
		e(t.filter((e) => V(e.url) !== "store"));
	}, [t, e]), null;
}
function fn() {
	let [e, t] = an(), { query: n } = oe(), [r, i] = o(0), [a, s] = o([]), l = v(() => Vt(), []), u = v(() => Ht(l, n), [l, n]);
	return /* @__PURE__ */ N(c, { children: [
		/* @__PURE__ */ N(cn, {
			activeTab: e,
			onSelect: t,
			counts: {
				products: r,
				pages: a.length,
				stores: u.length
			}
		}),
		/* @__PURE__ */ N(H, {
			indexName: "shopify_products",
			indexId: te,
			children: [/* @__PURE__ */ N(un, { onChange: i }), /* @__PURE__ */ N("div", {
				className: e === "products" ? void 0 : "hidden",
				children: [/* @__PURE__ */ N(B, { hitsPerPage: 12 }), /* @__PURE__ */ N(Rt, {})]
			})]
		}),
		/* @__PURE__ */ N(H, {
			indexName: "shopify_pages_and_metaobjects",
			indexId: P,
			children: [
				/* @__PURE__ */ N(B, { hitsPerPage: 1e3 }),
				/* @__PURE__ */ N(dn, { onChange: s }),
				/* @__PURE__ */ N("div", {
					className: e === "pages" ? "bg-brand-lightest" : "hidden",
					children: /* @__PURE__ */ N(At, { pages: a })
				})
			]
		}),
		e === "stores" && /* @__PURE__ */ N("div", {
			className: "bg-brand-lightest",
			children: /* @__PURE__ */ N(qt, { stores: u })
		})
	] });
}
var pn = {
	id: "SearchQueryPage",
	"data-search-page-input": ""
};
function mn() {
	let e = ue();
	return /* @__PURE__ */ N(T, {
		searchClient: en,
		indexName: $t,
		routing: on,
		children: [
			/* @__PURE__ */ N(C, {}),
			/* @__PURE__ */ N(ln, {}),
			/* @__PURE__ */ N(le, {
				queryHook: e,
				className: "col-span-full",
				classNames: {
					root: "",
					form: "mx-auto w-full lg:max-w-2xl px-safe-or-2 mb-4 relative flex items-center",
					input: "no-clear-button bg-brand-lighter outline-none focus-visible:outline-brand-focus transition-colors w-full placeholder-brand-dark rounded-full h6 leading-none py-4 pr-14 pl-[50px]",
					reset: "absolute right-6 focus-visible:outline-brand-focus underline",
					submit: "absolute left-6",
					loadingIndicator: "absolute right-6"
				},
				submitIconComponent: ({ classNames: e }) => /* @__PURE__ */ N("span", {
					className: e.submitIcon,
					children: /* @__PURE__ */ N("svg-icon", { src: "icon-search" })
				}),
				resetIconComponent: ({ classNames: e }) => /* @__PURE__ */ N("span", {
					className: e.resetIcon,
					children: window.generalStrings.search.clear
				}),
				placeholder: window.generalStrings.search.pagePlaceholder,
				inputProps: pn
			}),
			/* @__PURE__ */ N(Bt, {}),
			/* @__PURE__ */ N(fn, {})
		]
	});
}
var hn = document.getElementById("search-page");
hn && ne.createRoot(hn).render(/* @__PURE__ */ N(mn, {}));
//#endregion
